export default "__VITE_ASSET__CjjPlCsa__"